/**
 * Роут-модал тарифов: /tariffs, открытый ИЗНУТРИ приложения, рендерится
 * оверлеем поверх текущей страницы — подложка не размонтируется, закрытие
 * (крестик Tariffs → navigate(-1), Escape) мгновенное, без «перезагрузки».
 * Прямой заход/refresh по URL остаётся полной страницей (SEO, гости) —
 * App подсовывает <Routes> предыдущую локацию только для внутренних переходов.
 *
 * Бэкдроп-blur живёт на ::before (см. _tariffs.scss): backdrop-filter на самом
 * контейнере сделал бы его containing block для fixed-потомков — pay-overlay
 * платёжного модала начал бы скроллиться вместе с тарифами.
 */
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Tariffs from '../pages/Tariffs'
import { useScrollLock } from '../hooks/useScrollLock'

export default function TariffsRouteModal() {
	const navigate = useNavigate()

	// Скролл подложки заперт общим замком (прокручивается html, не body): замок на body схлопывал страницу, и под
	// окном она прыгала наверх — 1400 → 0 по замеру 11.10.
	useScrollLock(true)

	// Escape закрывает только окно тарифов: оно открывается и поверх шторок (их Escape на document), шторка под ним
	// закрываться вместе с ним не должна — перехват на window до остальных, как у окна входа
	useEffect(() => {
		const onKey = (e: KeyboardEvent) => {
			if (e.key !== 'Escape') return
			e.stopPropagation()
			navigate(-1)
		}
		window.addEventListener('keydown', onKey, true)
		return () => window.removeEventListener('keydown', onKey, true)
	}, [navigate])

	return (
		<div className="tariffs-route-modal" role="dialog" aria-modal="true" aria-label="Тарифы">
			<Tariffs />
		</div>
	)
}
